import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["level"];
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { HEADING_TYPES } from '../../constants';
import CustomPropTypes from '../../util/custom-prop-types';
import { StyledHeading } from './Heading.styles';

/**
 * An alias for heading types of the `Text` component.
 *
 * @extends Text
 * @related ['Paragraph']
 * @since 6.0.0
 */
export var Heading = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var _theme$theme$NAMESPAC;
  var level = _ref.level,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useContext(ThemeContext);
  var defaultFontFamily = (_theme$theme$NAMESPAC = theme === null || theme === void 0 ? void 0 : theme[theme.NAMESPACE].Heading.defaultFontFamily["h" + level]) !== null && _theme$theme$NAMESPAC !== void 0 ? _theme$theme$NAMESPAC : 'sansSerif';
  return /*#__PURE__*/React.createElement(StyledHeading, _extends({
    as: "h" + level,
    fontType: HEADING_TYPES[level],
    ref: forwardedRef
  }, props, {
    fontFamily: props.fontFamily || defaultFontFamily
  }));
});
Heading.displayName = 'Heading';
Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  /** A string or number representing the heading level */
  level: PropTypes.oneOf(['1', '2', '3', '4', '5', '6', 1, 2, 3, 4, 5, 6]).isRequired,
  /** Change the font family of the heading */
  fontFamily: PropTypes.oneOf(['serif', 'sansSerif']),
  /**
   * Change the text alignment of the heading.
   *
   * Supports inline media query objects.
   */
  textAlign: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['left', 'center', 'right'])),
  /**
   * Change the text wrapping of the heading.
   *
   * Note: This feature is a part of [CSS Text Level 4](https://www.w3.org/TR/css-text-4/#text-wrap)
   * and not yet supported across all browsers.
   *
   * Supports inline media query objects.
   */
  textWrap: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['wrap', 'nowrap', 'balance', 'stable', 'pretty'])),
  /**
   * The styled-components
   * [polymorphic "as"](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
} : {};